<template>
    <div>

        <Dialog

                :dismissableMask="true"
                :style="{ width: `${width}vw`}"
                :modal="true"
                :visible.sync="show"
                @hide="cancel"
                closeOnEscape
                :contentStyle="{overflow: 'visible'}"
                :maximizable="true"
                :showHeader="showHeader"
        >
            <template v-if="showHeader" #header>

                <i style=" transform: scale(1.7); " class="pi pi-pencil"></i>
                <h1>{{ title }}</h1>

            </template>
            <ScrollPanel  v-if="scrollable" :style=" {'height': `${height}vh`}"  :class="isLimitHeight ?  '': 'aa' ">
                <slot  name="content"/>
                <ScrollTop  v-if="scrollable" target="parent" :threshold="30" class="p-p-5 custom-scrolltop"
                           icon="pi pi-arrow-up"/>

            </ScrollPanel>
            <template v-if="showFooter" #footer>
                <Button
                        label="ביטול"
                        icon="pi pi-times"
                        @click="cancel"
                        class="p-button-secondary"
                />
                <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="agree"/>
            </template>
        </Dialog>
    </div>
</template>

<script>

export default {
    service: null,
    props: {
        show: {
            type: Boolean,
            default: false
        },
        isLimitHeight: {
            type: Boolean,
            default: true
        },
        height: {
            type: Number,
            default: 70
        },
        width: {
            type: Number,
            default: 50
        },
        scrollable: {
            type: Boolean,
            default: false
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: null
        },
    },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        agree() {
            this.$emit("agree");
        },
    },
};
</script>

<style>
.aa {
    /*height: 50vh !important;*/
    /*height: 85vw !important;*/

}

.p-dialog-maximized .aa {
    /*height: 75vh !important;*/

}

@media screen and (min-width: 992px) {
    .p-dialog {
        width: 65vw !important;
        /*height: 85vh !important;*/

    }

    .aa {
        height: 90vh !important;
    }

    #p {
        height: 20% !important;
    }

    .p-dialog-maximized .aa {
        height: 90vh !important;
    }


    .p-scrollpanel-wrapper {

    }

    .p-scrollpanel-content {
    }
}

@media screen and (max-width: 992px) {
    .p-dialog {
        width: 90vw !important;
        /*height: 85vh !important;*/

    }


}

@media screen and (  max-width: 768px) {
    .p-dialog {
        width: 75vw !important;
        /*height: 85vh !important;*/

    }

}

@media screen and (max-width: 576px) {
    .p-dialog {
        width: 85vw !important;
        /*height: 85vh !important;*/
    }

    .p-dialog-maximized {
    }


    .p-dialog-maximized .aa {
        /*height: 70vh !important;*/
    }

    .p-scrollpanel-wrapper {
    }
}

.p-dialog-maximized {
    width: 100vw !important;
    /*height: 100vh !important;*/
}

.aa {
    /*height: 50vh !important;*/
    /*height: 75vh !important;*/

}

.p-dialog-maximized .aa {
    /*height: 75vh !important;*/
}

.p-scrolltop.p-link {
    background:  var(--primary-color) !important
;
}
.p-scrolltop-sticky.p-link {
  /* margin-top: auto; */
  margin-left: 30px !important;

  margin-right: auto !important;
}

p-scrolltop {
    bottom: 30px;
}

.p-scrolltop-icon {
  font-size: 1rem;
  color: unset !important;
}


/*.p-dialog-header{*/
/*  background:  #fbbf2c !important;*/
/*}*/

</style>